import { HttpService } from '@maia/httpClient';
import { BaseService } from '@maia/feature-utils';
import { ConfigService } from '@maia/config';
import { IAttachmentEntity } from '../../entitites/attachments.entity';

export class AttachmentService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async findMany(path: string, search: Record<string, unknown>) {
    return this.getMany<IAttachmentEntity>(path, search, 'documents');
  }

  public async find(guid: string) {
    return this.get<IAttachmentEntity>(guid, 'document');
  }
}
